import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useStorage } from '@vueuse/core'
// import SecureLS from 'secure-ls'

// const ls = new SecureLS({ encodingType: 'aes', isCompression: false, encryptionSecret: 'vcy6u05eq7Vi+MKssWx+Ly0Tm5lHAwjmwXTHDnMU/bI=' })
// const ls = new SecureLS({ isCompression: false })

export const stores = defineStore('pymesonline', () => {
  const rules = ref(null)
  const user = ref({})
  const token = ref({ id: 0, text: '' })
  const apiUrl = ref('')
  const auth = ref(false)
  const expira = ref(null)
  const prefix = ref('')
  const state = useStorage('pymesonline_store', { colores: {}, theme: 1, rules: rules.value, user: user.value, token: token.value, apiUrl: apiUrl.value, auth: auth.value, expira: expira.value, prefix: prefix.value, dark: false })

  // getters
  const getTheme = computed(() => state.value.theme)
  const getColores = computed(() => state.value.colores)
  const getRules = computed(() => state.value.rules)
  const getUser = computed(() => state.value.user)
  const getToken = computed(() => state.value.token)
  const getUrlApi = computed(() => state.value.apiUrl + 'api/')
  const getStorage = computed(() => state.value.apiUrl + 'storage/')

  const getAuth = computed(() => state.value.auth)
  const getExpira = computed(() => state.value.expira)
  const getPrefix = computed(() => state.value.prefix)
  const getDark = computed(() => {
    return state.value.colores.isDark ?? false
  })

  const setTheme = (pValue) => {
    state.value.theme = pValue
  }

  const theme = computed({
    get: () => state.value.theme,
    set: (value) => {
      state.value.theme = value
    }
  })

  const colores = computed({
    get: () => state.value.colores,
    set: (value) => {
      state.value.colores = value
    }
  })

  // Action
  const setColores = (pValue) => {
    state.value.colores = pValue
  }

  const setRules = (pValue) => {
    state.value.rules = pValue
  }

  const setUser = (pValue) => {
    state.value.user = pValue
  }

  const setToken = (pValue) => {
    state.value.token = pValue
  }

  const setUrlApi = (pValue) => {
    state.value.apiUrl = pValue
  }

  const setAuth = (pValue) => {
    state.value.auth = pValue
  }

  const setExpira = (pValue) => {
    state.value.expira = pValue
  }

  const setPrefix = (pValue) => {
    state.value.prefix = pValue
  }

  const setDark = (pValue) => {
    state.value.colores.isDark = pValue
  }

  return { colores, theme, getColores, getRules, getUser, getToken, getUrlApi, getStorage, getAuth, getExpira, getPrefix, getDark, getTheme, setTheme, setColores, setRules, setUser, setToken, setUrlApi, setAuth, setExpira, setPrefix, setDark }
})
